const links: [string, string][] = [
  ["privacy", "プライバシーポリシー"],
  ["terms", "利用規約"],
  ["tokushoho", "特定商取引法に基づく表記"],
  ["refund", "返品ポリシー"],
  ["contact", "お問い合わせ"],
];

export default function Footer() {
  return (
    <footer className="app-footer">
      <div className="app-footer-inner">
        <div className="app-footer-links">
          {links.map(([path, label]) => (
            <a
              key={path}
              href={`https://yakizakana.net/${path}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {label}
            </a>
          ))}
        </div>
        <p>© 2026 yakizakana.net — made quietly, in tokyo</p>
      </div>
    </footer>
  );
}
